import React from 'react'
import { Spin } from 'antd'

export default () => (
  <div style={{ paddingTop: 100, textAlign: 'center' }}>
    <Spin size="large" />
  </div>
)
